import Option from './option';

class GoogleOption extends Option {
  #placeId;

  #googleOptionService;

  #details;

  constructor(description, logo, placeId, googleOptionService) {
    super(description, logo);
    this.#placeId = placeId;
    this.#googleOptionService = googleOptionService;
  }

  async fetchDetails() {
    if (this.#details) {
      return this.#details;
    }
    this.#details =
      await this.#googleOptionService.getAddressAndLocationDetails(this.#placeId, this.description);
    return this.#details;
  }
}

export default GoogleOption;
